<template>
    <div class="product-list__item__img-text-label product-list__item__img-text-label--category-page">
        <i class="fas fa-exclamation-circle"></i>
        <span>{{alertLabel}}</span>
    </div>
</template>

<script>
export default {
    name: "ActionLabel",
    props: {
        alertLabel: {
            type:[Boolean, String],
            required: true,
        }
    }
};
</script>